/**
 * @fileoverview smooths over inconsistencies with fetch api and wires it up for use with the Dashboard endpoints
 * @note we dont expect to do cross-origin fetches with this library but it is possible
 */

import { FetchInvalidJsonError } from "@lib/errors";

import { extractResponseOrThrowBrazeServerSideError } from "./utils/extractResponseOrThrowBrazeServerSideError";
import { fetchBase } from "./fetchBase";
import type { FetchMethod, FetchOptions, SettingsOptions } from "./types";

export const brazeFetch = async <R = any>(
  url: string,
  method: FetchMethod,
  params: Record<string, any> = {},
  options: FetchOptions = {},
  settings: SettingsOptions = {
    setContentType: true,
    returnDetailedError: false,
    returnFetchRequestError: false,
    fetchBlobType: false,
  }
): Promise<R> => {
  const response = await fetchBase(url, method, params, options, settings);
  // For requests that have no response body
  // response.json() would err otherwise
  if (response.status === 204) {
    // Note: Casting here is required because we are expected to return type R
    // we should probably just not return any value here rather than returning true
    // For now, just ignore to avoid breaking existing implementations
    // @ts-ignore
    return true;
  }
  const payloadText = await response.text();
  try {
    const payload = JSON.parse(payloadText);
    return extractResponseOrThrowBrazeServerSideError<R>(payload);
  } catch (e) {
    throw new FetchInvalidJsonError(500, `Invalid JSON response from server for ${method} ${url}`, {
      response: payloadText,
    });
  }
};
